import React, { useEffect, useState } from "react";
import Logo from "@/components/Logo";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { href: "#services", label: "Services", testId: "nav-services" },
  { href: "#quiz", label: "Diagnostic", testId: "nav-quiz" },
  { href: "#cas-clients", label: "Cas clients", testId: "nav-cases" },
  { href: "#approche", label: "Approche", testId: "nav-approche" },
  { href: "#faq", label: "FAQ", testId: "nav-faq" },
  { href: "#contact", label: "Contact", testId: "nav-contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050A07]/75 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="text-sm text-gray-300 hover:text-emerald-400 transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-emerald-400 group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#quiz"
            data-testid="nav-cta-button"
            className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-black font-medium text-sm transition-all hover:-translate-y-[1px]"
          >
            Tester ma maturité
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 text-white"
          aria-label="menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/5 bg-[#050A07]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testId}`}
                className="text-gray-300 hover:text-emerald-400 py-2 border-b border-white/5"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quiz"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta-button"
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-emerald-500 text-black font-medium"
            >
              Tester ma maturité <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
